import { Alert, ButtonLink } from '@designsforhealth/dfh-react-components'
import React from 'react'
import styled from 'styled-components'

const StyledErrorActions = styled.div`
  margin-top: 1.5em;
  display: flex;
  justify-content: space-between;
`

export interface MutationErrorAlertProps {
  cancelButtonText?: string
  className?: string
  children: React.ReactNode
  onCancel(e?: React.BaseSyntheticEvent): void
  onRetry(e?: React.BaseSyntheticEvent): void
}

export const MutationErrorAlert: React.FC<MutationErrorAlertProps> = ({
  cancelButtonText = 'Cancel Update',
  className,
  children,
  onCancel,
  onRetry,
}) => {
  return (
    <Alert className={className} type="error" onDismiss={onCancel}>
      {children}
      <StyledErrorActions>
        <ButtonLink onClick={onRetry} underline>
          Retry
        </ButtonLink>
        <ButtonLink onClick={onCancel} underline>
          {cancelButtonText}
        </ButtonLink>
      </StyledErrorActions>
    </Alert>
  )
}
